import React from "react";

export default function InventoryMoveProjectById (){return <h1>MoveById</h1>}